import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { getBasePath } from '../utils/getBasePath';

import { useExeptions } from './useExeptions';

export const useSelectedV2 = () => {
  const location = useLocation();

  const basePath = getBasePath(location.pathname);
  const pathname = useExeptions(basePath);

  const [selected, setSelected] = useState(pathname);

  useEffect(() => {
    setSelected(pathname);
  }, [pathname]);

  return selected;
};
